import moment from "moment";

export default {
    computed: {
        isAfter2023Year() {
            return moment().isAfter('01-01-2023')
        }
    }
}
